"use client";

import { useState } from "react";
import { isBrokenAvatar } from "@/app/lib/avatar";

interface AvatarProps {
    src?: string | null;
    username: string;
    /** Applied to both the <img> and the initial-letter fallback. */
    className?: string;
    /** Extra classes for the initial-letter fallback only (background, text size). */
    fallbackClassName?: string;
}

export default function Avatar({ src, username, className = "", fallbackClassName = "" }: AvatarProps) {
    const [failed, setFailed] = useState(false);

    if (!src || failed || isBrokenAvatar(src)) {
        return (
            <div className={`${className} flex items-center justify-center font-semibold text-white ${fallbackClassName}`}>
                {username.charAt(0).toUpperCase()}
            </div>
        );
    }

    return (
        // eslint-disable-next-line @next/next/no-img-element
        <img
            src={src}
            alt=""
            onError={() => setFailed(true)}
            className={`${className} object-cover`}
        />
    );
}
